import { getRole, getRentDate } from "../../functions/user";

import Row from "../common/List/Row";

const UserRow = ({ user, setShowPopUp, setCurUser }) => {
  const showPopUp = () => {
    setShowPopUp(true);
    setCurUser(user);
  };

  const cellTexts = [
    user.memberNumber,
    user.name,
    user.phoneNumber,
    getRole(user),
    user.idNumber,
    user.profession,
    user.hasLineId ? "✅" : "",
    user.roomNumber,
    getRentDate(user),
  ];

  const cellAlign = ["L", "L", "L", "C", "L"];

  return (
    <Row
      cellTexts={cellTexts}
      noteTexts={[user.note]}
      showPopUp={showPopUp}
      cellAlign={cellAlign}
    />
  );
};
export default UserRow;
